export const en = {
  // Navigation
  nav: {
    home: "Home",
    shop: "Shop",
    lighting: "Lighting",
    electricity: "Electricity",
    hardware: "Hardware",
    accessories: "Accessories",
    cart: "Cart",
    search: "Search",
    menu: "Menu",
    sale: "Sale",
    allCategories: "All Categories",
  },
  
  // Categories
  categories: {
    lighting: "Lighting",
    electricity: "Electricity",
    hardware: "Hardware",
    accessories: "Accessories",
    kitchens: "Kitchen",
    // Lighting subcategories
    chandeliers: "Chandeliers",
    ceilingLights: "Ceiling Lights",
    wallLights: "Wall Lights",
    outdoorLighting: "Outdoor Lighting",
    lightBulbs: "Light Bulbs",
    // Electricity subcategories
    lightSwitches: "Light Switches",
    dimmerSwitches: "Dimmer Switches",
    plugSockets: "Plug Sockets",
    backBoxes: "Back Boxes",
    plates: "Plates",
    modules: "Modules",
    otherSwitches: "Other Switches",
    toggleSwitches: "Toggle Switches",
    rockerSwitches: "Rocker Switches",
    ukProducts: "UK Products",
    doorHandle: "Door Handle",
    fixedDoorHandle: "Fixed Door Handle",
    doorKnob: "Door Knob",
    fixedDoorKnob: "Fixed Door Knob",
    doorHinge: "Door Hinge",
    doorStop: "Door Stop",
    closetBar: "Closet Bar",
    deadboltLatch: "Deadbolt Latch",
    mirror: "Mirror",
    spares: "Spares",
    // Accessories subcategories
    jewellery: "Jewellery",
    pets: "Pets",
    machined: "Machined",
    // Kitchen subcategories
    cookware: "Cookware",
    mixerFaucets: "Kitchen Taps",
    kitchenFaucets: "Kitchen Faucets",
    kitchenShelves: "Kitchen Shelves",
    kitchenGirderShelf: "Girder Shelf",
    kitchenHangerShelf: "Hanger Shelf",
    fryingPans: "Frying Pans",
    pots: "Pots",
    // Deante product types - Kitchen
    sinks: "Sinks",
    graniteSinks: "Granite Sinks",
    steelSinks: "Steel Sinks",
    ceramicSinks: "Ceramic Sinks",
    soapDispensers: "Soap Dispensers",
    drainers: "Drainers",
    baskets: "Baskets",
    cuttingBoards: "Cutting Boards",
    kitchenAccessories: "Kitchen Accessories",
    // Deante product types - Bathroom
    bathroomFaucets: "Bathroom Faucets",
    basinFaucets: "Basin Faucets",
    bathFaucets: "Bath Faucets",
    showerFaucets: "Shower Faucets",
    bidetFaucets: "Bidet Faucets",
    concealedFaucets: "Concealed Faucets",
    showerSystems: "Shower Systems",
    showerColumns: "Shower Columns",
    showerHeads: "Shower Heads",
    handShowers: "Hand Showers",
    showerTrays: "Shower Trays",
    showerEnclosures: "Shower Enclosures",
    showerDrains: "Shower Drains",
    basins: "Basins",
    toilets: "Toilets",
    toiletSeats: "Toilet Seats",
    toiletPaperHolders: "Toilet Paper Holders",
    toiletFrames: "Toilet Frames",
    bidets: "Bidets",
    bathroomAccessories: "Bathroom Accessories",
    towelRails: "Towel Rails",
    soapDishes: "Soap Dishes",
    tumblers: "Tumblers",
    toiletBrushes: "Toilet Brushes",
    dispensers: "Dispensers",
    mirrors: "Mirrors",
    bathroomShelves: "Bathroom Shelves",
    bathroomFurniture: "Bathroom Furniture",
    bathroomCabinets: "Bathroom Cabinets",
    vanityUnits: "Vanity Units",
    kitchen: "Kitchen",
    bathroom: "Bathroom",
    pendants: "Pendants",
    tableLamps: "Table Lamps",
    floorLamps: "Floor Lamps",
    spotLights: "Spot Lights",
    keyrings: "Keyrings",
    gifts: "Gifts",
    // Additional Deante subcategories
    bathtubs: "Bathtubs",
    freestandingBath: "Freestanding Baths",
    builtInBath: "Built-in Baths",
    bathSpouts: "Bath Spouts",
    showerRails: "Shower Rails",
    basinWaste: "Basin Waste",
    showerWaste: "Shower Waste",
    radiatorValves: "Radiator Valves",
    rails: "Rails",
    wcFlushButtons: "WC Flush Buttons",
  },

  // Hero section
  hero: {
    title: "Where",
    titleAccent: "Design",
    titleEnd: "Becomes Art",
    subtitle: "Curated collection of premium architectural hardware, lighting, kitchen solutions & interior details. For those who believe every switch, handle, tap and fixture should be a masterpiece.",
    shopCollection: "Explore Collection",
    exploreRange: "Explore Range",
  },

  // Product
  product: {
    addToCart: "Add to Cart",
    outOfStock: "Out of Stock",
    quantity: "Quantity",
    sku: "SKU",
    price: "Price",
    finish: "Finish",
    size: "Size",
    logo: "Logo",
    knurl: "Knurl",
    viewDetails: "View Details",
    viewAll: "View All",
    noProducts: "No Products Found",
    noProductsDesc: "Try adjusting your filters or browse all products.",
    clearFilters: "Clear Filters",
    featuredProducts: "Featured Products",
    shopFullCollection: "Shop Full Collection",
  },

  // Shop page
  shop: {
    title: "Shop All Products",
    subtitle: "Explore our complete collection of premium architectural hardware, lighting, and electrical accessories.",
    collection: "Collection",
    category: "Category",
    allCategories: "All Categories",
    productType: "Product Type",
    allTypes: "All Types",
    collectionFilter: "Collection",
    allCollections: "All Collections",
    brand: "Brand",
    allBrands: "All Brands",
    sortBy: "Sort by",
    default: "Default",
    priceLowHigh: "Price: Low to High",
    priceHighLow: "Price: High to Low",
    nameAZ: "Name: A to Z",
    nameZA: "Name: Z to A",
    show: "Show",
    items: "",
    clearAll: "Clear all",
    products: "products",
    hideUKProducts: "Hide UK Products",
    product: "product",
    loading: "Loading...",
    previous: "Previous",
    next: "Next",
    searchPlaceholder: "Search products...",
    noProducts: "No products found",
    loadAllProducts: "Load all products",
    loadingAll: "Loading all...",
    price: "Price",
    priceRange: "Price Range",
  },

  // Product detail
  productDetail: {
    home: "Home",
    products: "Products",
    fastShipping: "Fast Shipping",
    warranty: "Warranty",
    returns: "30-Day Returns",
    lifestyle: "Lifestyle",
    details: "Details",
    whatsInBox: "What's in the Box",
    specifications: "Specifications",
    dimensions: "Dimensions",
    electrical: "Electrical",
    lightingSpecs: "Lighting",
    hardwareSpecs: "Hardware",
    documents: "Documents",
    lineDrawing: "Line Drawing",
    specSheet: "Spec Sheet",
    instructionManual: "Instruction Manual",
    download: "Download",
    noImage: "No image",
    productNotFound: "Product not found",
    backToStore: "Back to Store",
    imageDisclaimer: "The image is for illustration purposes only and the product may differ from what is shown.",
    components: "Components",
    componentsDesc: "This product consists of the following items:",
    // Package dimensions section
    packageDimensions: "Package Dimensions",
    productDimensions: "Product Dimensions",
    width: "Width",
    height: "Height",
    length: "Length",
    weight: "Weight",
    minWidth: "Min. Width",
    minHeight: "Min. Height",
    // Specs labels
    packageWidth: "Package Width",
    packageHeight: "Package Height",
    packageLength: "Package Length",
    packageWeight: "Package Weight",
    itemWeight: "Item Weight",
    minLength: "Length",
    internalDepth: "Internal Depth",
    externalDepth: "External Depth",
    projection: "Projection",
    voltage: "Voltage",
    amperage: "Amperage",
    frequency: "Frequency",
    ipRating: "IP Rating",
    ceGrade: "CE Grade",
    numBulbs: "Number of Bulbs",
    bulbBase: "Bulb Base",
    bulbType: "Bulb Type",
    maxWattage: "Max Wattage",
    lumen: "Lumens",
    dimmable: "Dimmable",
    kelvin: "Color Temperature",
    cri: "CRI",
    lifeHours: "Life Hours",
    cordLength: "Cord Length",
    distanceBetweenHoles: "Hole Spacing",
    roseDiameter: "Rose Diameter",
    barDiameter: "Bar Diameter",
    spindleDimension: "Spindle Size",
    plateMaterial: "Plate Material",
    switchType: "Switch Type",
  },

  // Cart
  cart: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    emptyDesc: "Add some products to get started",
    continueShopping: "Continue Shopping",
    subtotal: "Subtotal",
    subtotalExVat: "Subtotal (excl. VAT)",
    vatAmount: "VAT (21%)",
    checkout: "Checkout",
    remove: "Remove",
    addedToCart: "Added to cart",
    viewCart: "View cart",
    // Business customer cart
    businessCheckout: "Order with Invoice",
    shopifyCheckout: "Pay Now",
    yourDiscount: "Your discount",
    vatIncluded: "VAT (21%) included in price",
    orderPlaced: "Order placed successfully",
    orderPlacedDesc: "Invoice will be sent to your email",
    paymentTerms: "Payment terms",
    days: "days",
    total: "Total",
    // Shipping & Delivery
    shippingCountry: "Delivery country",
    selectCountry: "Select country",
    shipping: "Shipping",
    freeShipping: "Free",
    freeShippingFrom: "Free shipping from",
    calculatedAtCheckout: "Calculated at checkout",
    shippingNote: "Select shipping method at checkout",
    selectCountryForShipping: "Select country",
    secureCheckout: "Secure checkout powered by Shopify",
    agreeToTerms: "I agree to the",
    purchaseTermsLink: "Purchase Terms",
    deliveryAddress: "Delivery Address",
    deliveryMethod: "Delivery Method",
    pickupInStore: "Pickup in Store",
    free: "FREE",
    deliveryToAddress: "Delivery to Address",
    deliveryPriceNote: "Delivery cost depends on weight and country",
    savedAddress: "Saved Address",
    newAddress: "New Address",
    address: "Address",
    fillDeliveryAddress: "Please fill in all delivery address fields",
    back: "Back",
    backToCart: "Back to Cart",
    proceedToDelivery: "Proceed to Delivery",
    createInvoice: "Create Invoice",
    confirmOrder: "Confirm Order",
    invoiceWillBeSent: "Invoice will be sent to your email",
    country: "Country",
    city: "City",
    postalCode: "Postal Code",
    streetAddress: "Street, house no.",
    storePickup: "Store Pickup",
    // Omniva
    parcelLocker: "Parcel Locker",
    selectParcelLocker: "Select Parcel Locker",
    searchTerminals: "Search by city or address...",
    loadingTerminals: "Loading parcel lockers...",
    noTerminalsFound: "No parcel lockers found",
    terminalsAvailable: "parcel lockers available",
    omnivaDelivery: "Omniva Parcel Locker",
    omnivaNote: "Convenient 24/7 pickup from parcel locker",
    courierDelivery: "Courier Delivery",
    courierNote: "Delivery to your address",
    selectDeliveryMethod: "Select delivery method",
    orderNotes: "Order Notes",
    orderNotesPlaceholder: "Add any special instructions or notes for your order...",
    promoPlaceholder: "Promo code",
    applyPromo: "Apply",
    promoApplied: "Promo code applied!",
    promoInvalid: "Invalid promo code",
    promoRemoved: "Promo code removed",
    promoNotAvailableWithSale: "Promo codes cannot be applied to sale items",
  },

  // Business
  business: {
    login: "Business Login",
    register: "Business Registration",
    companyName: "Company Name",
    registrationNumber: "Registration Number",
    vatNumber: "VAT Number",
    contactName: "Contact Name",
    phone: "Phone",
    billingAddress: "Billing Address",
    city: "City",
    postalCode: "Postal Code",
    country: "Country",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    registerHere: "Register here",
    loginHere: "Login here",
    awaitingApproval: "Awaiting Approval",
    awaitingApprovalDesc: "Your business account is pending approval. You will be notified once approved.",
    dashboard: "Business Dashboard",
    yourOrders: "Your Orders",
    noOrders: "No orders yet",
    orderNumber: "Order Number",
    orderDate: "Order Date",
    status: "Status",
    total: "Total",
    paymentStatus: "Payment Status",
    dueDate: "Due Date",
    viewInvoice: "View Invoice",
  },

  // Footer
  footer: {
    company: "Company",
    about: "About Us",
    contact: "Contact",
    careers: "Careers",
    support: "Support",
    faq: "FAQ",
    shipping: "Shipping",
    returnsPolicy: "Returns",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    cookies: "Cookie Policy",
    newsletter: "Newsletter",
    newsletterDesc: "Subscribe for updates and exclusive offers",
    subscribe: "Subscribe",
    emailPlaceholder: "Enter your email",
    blog: "Blog",
    allRightsReserved: "All rights reserved",
    regNr: "Reg. No.",
    vatNr: "VAT No.",
    euSupportTitle: "EU Recovery Fund",
    euSupportText: "Limited liability company \"Royal Bathrooms\", reg. no. 40103384776, is making investments within the Recovery Fund to improve commercial business processes.",
    euSupportActivity: "Supported activity: sales processes",
    euSupportSolution: "Solution: a full-featured e-commerce solution for the company's online store development.",
    purchaseTerms: "Purchase Terms",
    workingHours: "Working Hours",
    workingHoursWeekdays: "Mon–Fri: 10:00–18:00",
    workingHoursSaturday: "Sat: 10:00–15:00",
    workingHoursSunday: "Sun: Closed",
  },

  // Purchase Terms
  purchaseTerms: {
    title: "Purchase Terms",
    metaDescription: "Purchase terms and conditions for HAUS online store — warranty, returns, pricing, delivery.",
    lastUpdated: "Last updated",
    warrantyTitle: "Warranty",
    warrantyIntro: "All products purchased at the online store www.haus.lv come with a manufacturer's warranty. The minimum warranty period for individuals is 24 months, in accordance with the laws of the Republic of Latvia. For certain products, the manufacturer may set a longer warranty period. To use the warranty, a proof of purchase document (invoice or waybill) must be presented.",
    warrantyItem1: "Product accessories and parts (e.g., batteries, bulbs, etc.) if their wear is natural.",
    warrantyItem2: "Parts whose wear is a normal result of use.",
    warrantyItem3: "Minor visual defects that do not affect the product's functionality.",
    warrantyExcludesTitle: "The warranty does not cover:",
    warrantyExclude1: "Product accessories and parts (e.g., batteries, bulbs, etc.) if their wear is natural.",
    warrantyExclude2: "Parts whose wear is a normal result of use.",
    warrantyExclude3: "Minor visual defects that do not affect the product's functionality.",
    warrantyVoidTitle: "The warranty is void if:",
    warrantyVoid1: "The product has been mechanically damaged or used in violation of the user manual.",
    warrantyVoid2: "Unauthorized repairs have been performed.",
    warrantyVoid3: "Damage has been caused by external factors (moisture, voltage fluctuations, fire, etc.).",
    warrantyVoid4: "Installation or operating conditions have not been followed.",
    warrantyLaw: "Warranty cases are handled in accordance with the laws of the Republic of Latvia.",
    withdrawalTitle: "Right of Withdrawal",
    withdrawalItem1: "The buyer (consumer) has the right to withdraw from the distance contract within 14 days from the date of receiving the product, without giving a reason.",
    withdrawalItem2: "The buyer is responsible for the decrease in value of the product if the product has been used more than necessary to verify its properties and operation.",
    withdrawalItem3: "The product must be returned in its original packaging and complete set.",
    withdrawalExcludesTitle: "The right of withdrawal does not apply to:",
    withdrawalExclude1: "Products made to individual order.",
    withdrawalExclude2: "Products that, after delivery, have been irreversibly mixed with others.",
    withdrawalExclude3: "Products that cannot be returned for hygiene reasons if they have been opened after delivery.",
    withdrawalRefund: "The refund is made within 14 days after receiving the withdrawal notice, but no earlier than after receiving the product back.",
    pricingTitle: "Prices and Availability",
    pricingItem1: "Prices and product availability in the online store may be changed without prior notice.",
    pricingItem2: "All prices are indicated in euros (EUR) including value added tax (VAT).",
    pricingItem3: "For EU companies that are VAT payers and are not located in Latvia, a 0% VAT rate may be applied in accordance with regulations.",
    privacyTitle: "Privacy Policy",
    privacyText: "Customer information is used only for order processing and customer service. Information is not shared with third parties, except when necessary for delivery or required by law.",
    privacyDataTitle: "Information required for order processing:",
    privacyData1: "First and last name",
    privacyData2: "Delivery address",
    privacyData3: "Contact phone number",
    privacyData4: "Email address",
    privacyEmail: "The email address is used for order confirmation and communication with the customer. Promotional messages are sent only with the customer's consent.",
    passwordTitle: "Password Security",
    passwordText: "Customer passwords are not stored in an accessible form. Password recovery is possible using the \"Forgot password\" function.",
    deliveryTitle: "Delivery Terms",
    deliveryItem1: "If the customer is unreachable during delivery or does not pick up the shipment within the specified period, re-delivery may be carried out for an additional fee.",
    deliveryItem2: "If the buyer cancels the order after it has been shipped, the seller has the right to deduct delivery costs from the refundable amount.",
    otherTitle: "Other Terms",
    otherText: "If the ordered product is not available due to technical or warehouse errors, the customer will be offered an alternative product or a full refund of the paid amount.",
  },

  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    or: "or",
  },

  // About section
  about: {
    tagline: "About HAUS",
    title: "Your Partner in",
    titleAccent: "Design Excellence",
    paragraph1: "HAUS is a curated destination for premium architectural hardware, lighting, and interior design elements. We bring together the world's finest brands for discerning homeowners, architects, and interior designers.",
    paragraph2: "Based in Latvia, we serve clients across the Baltic region and Europe, offering exclusive access to brands like Buster + Punch and other premium manufacturers.",
    paragraph3: "Every product in our collection is carefully selected for its exceptional craftsmanship, innovative design, and lasting quality. We believe that details matter – from the switch on your wall to the handle on your door.",
  },

  // Buster + Punch section
  busterPunch: {
    exclusivePartner: "EXCLUSIVE PARTNER",
    brandDescription: "London-born design brand crafting solid metal hardware, lighting, and interior details with unmistakable character and attitude.",
    theStory: "THE STORY",
    mastersOfMetal: "Masters of Metal Since 2013",
    storyParagraph1: "Buster + Punch was founded in 2013 by architect Massimo Buster Minale with the goal of creating the world's finest solid metal interior details. Today, inspired and fuelled by the changing cultural undercurrents of London, Buster + Punch's collections transform homes and spaces globally.",
    storyParagraph2: "To industry insiders, the brand is undisputed as the master of metal, creating sophisticated functional pieces that elevate the spaces they inhabit but also evoke passion and individuality. Buster + Punch's uncompromising attention to detail and use of premium solid metals have put interior details on par with statement furniture when creating expressive spaces.",
    storyParagraph3: "With an aesthetic and brand identity that's more akin to cult high-end fashion labels, Buster + Punch is an attitude and lifestyle for its followers. Collaborations blend design with fashion, music, art and culture.",
    storyHighlight: "The first to bring precision knurling to interior hardware. The name that epitomises solid metal switches and outlets. The first brand in the world to release a designer LED lightbulb in 2015.",
    discoverCollection: "Discover the Full Collection",
    discoverCollectionDesc: "Explore the complete range of Buster + Punch products available through HAUS",
    shopBusterPunch: "SHOP BUSTER + PUNCH",
    founderQuote1: "I am proud that we were the first to bring functional home fittings to life, through our passion for metals. Our originality, unique perspective and approach have carved out new paths in interiors for a decade.",
    founderQuote2: "As a brand, we've always embraced change. Today, our world differs vastly from our small garage beginnings. Back then, inspiration bloomed from the cracks of London's pavements, whereas now, our skyline soars and social media strives to isolate and detach us from the streets we once walked. These changes are opportunities to unearth new inspirations, talents and techniques while staying true to our roots.",
    founderQuote3: "As a brand, we pledge to be more responsible and ensure our products remain meaningful and unique. We'll stay analogue and tactile while looking forward - melding tradition with technology to shape new chapters. Pushing industry boundaries and drawing inspiration from our city's subcultures, we promise to prioritise our people, customers and community, placing them at the centre of our world.",
    founderName: "MASSIMO BUSTER MINALE",
    founderRole: "Founder and Creative Director",
    // Electricity Collection
    electricityTitle: "Electricity Collection",
    electricitySubtitle: "EUROPEAN RANGE",
    electricityDesc: "Buster + Punch's in-demand ELECTRICITY collection is now available as an European-specific range. An extensive range of light switches, dimmers, outlets and sockets that literally alter your perceptions of home detailing at the flick of a switch.\n\nDesigned in London and inspired by mixer boards and amps, the range is made from solid precious metals, knurled using diamond-tipped CNC lathes and refined precisely by hand.\n\nELECTRICITY is the product of Buster + Punch's ethos to transform 'ordinary' products, designs and details into extraordinary experiences. As a range, they open up a new way to design with details, linking rooms and spaces together with a tactile red thread.\n\nThe collection is available in complete fixtures or custom modular sets with 11 different combinations. Choose from steel, brass, smoked bronze, black and white. The range also features 'retractive switches' that can be used with smart home solutions.",
    electricityQuote: "We've always felt that there's a lack of beauty and feeling in interior detailing when it comes to these items. They're essential fittings but it's hard to understand why nobody has invested care and passion into them before. In other areas of our lives, switches and knobs are given beautiful designs and treatments – cars for example, or guitar amps, even remote controls.",
    // Linear Series
    linearTitle: "Linear Series — Switches, Dimmers & Outlets",
    linearSubtitle: "THE ICONS REFORM NEW LOOK",
    linearDesc: "Buster + Punch returns to the mixing desk this summer to rework its iconic solid metal toggle switches, dimmers, and outlets – this time with the brand's precision-crafted linear knurl as its driving aesthetic. Drawing inspiration from classic analogue amplifiers and the world of Swiss horology, these must-have interior details have been reimagined with meticulous attention to detail.\n\nBuster + Punch's solid metal, precision-knurled switches, dimmers, and outlets are among the world's most sought-after interior details. Loved by A-listers, designers, architects, and tastemakers alike, their premium materials and unmistakable analogue action captivate anyone who interacts with them.\n\nThe new switches, dimmers, and outlets complete the Linear series and extend the range with perfect continuity. The collection joins Buster + Punch's comprehensive interior detailing, letting you run the Linear look throughout your home's hardware, lighting, accessories, and now switching.\n\nAvailable in solid metal finishes including white, steel, brass, smoked bronze and black. Fully certified for EU, North America, UK, Australia and New Zealand.",
    // Boiling Tap
    boilingTapTitle: "Instant Boiling Water Tap",
    boilingTapSubtitle: "KITCHEN INNOVATION",
    boilingTapDesc: "Buster + Punch's new instant boiling water tap brings the convenience of chilled filtered water and instant boiling water to the kitchen, blended with its signature aesthetic + attitude.\n\nDeveloped with one of Europe's leading tap producers, the tap has been designed from the ground up using Buster + Punch's experience in working with solid metals. With a rough-cast metal base, custom insulated brushed metal neck, cross or linear knurled solid metal lever, plus matching knurled aerator cap and function dial.\n\nAt a simple flick of its knurled function dial, you can pour the perfect glass of filtered cold water, make a hot beverage, or speed up cooking with instant 98-degree water. The tap comes with fully customisable settings, and features to prevent accidental activation of the instant hot water.\n\nThe unique aesthetic stance of Buster + Punch's tap complements its signature range of cabinet hardware, creating a seamless coherence throughout any kitchen space.",
    // Kitchen
    kitchenTitle: "The Buster + Punch Kitchen",
    kitchenSubtitle: "MODULAR FREESTANDING DESIGN",
    kitchenDesc: "Gone are the days of fitted kitchens with short lifecycles and limited flexibility. The Buster + Punch Kitchen is a new way to curate a custom-built, modular, freestanding kitchen.\n\nConfigured online and made with the precision and engineering of its acclaimed solid metal hardware, the kitchen carries the level of aesthetics and quality you'd expect to find in bespoke furniture.\n\nInspired by the professional chef's freestanding kitchen, the design strips back the elements of the modular units. The kitchen is curated from two frame options, three cabinet colour ways, and three worktops, designed around the brand's endless choices of iconic hardware – the jewellery of The Buster + Punch Kitchen.\n\nThe kitchen units have an edge-to-edge countertop in stone or metal with a unique corner radius that matches the extruded metal frame. The frame itself has precision cast aluminium legs which rest on custom-turned brass or stainless-steel adjustable feet, finished with the brand's signature diamond-cut knurling.",
    kitchenQuote: "We wanted to flip the conventions of kitchen design, using hardware and detailing as the launchpad for the entire process. It's resulted in a kitchen that's adaptable, usable, and feels like it's been machined from one solid piece of metal and stone.",
  },

  // Brand page
  brandPage: {
    founded: "Founded",
    origin: "Origin",
    website: "Website",
    catalog: "Catalog",
    busterPunchDescription: "Buster + Punch is a London-born interiors brand on a mission to change the details inside homes and commercial spaces across the globe. Founded in 2013 by Massimo Minale, the brand creates extraordinary fittings for everyday use - from switches and door hardware to lighting and bespoke kitchens. Each piece is designed in London and made from solid, high-grade metals with a focus on craftsmanship and premium finishes.",
    deanteDescription: "Deante is a leading European manufacturer of bathroom and kitchen equipment. With modern design, functionality, and high standards in mind, Deante pays special attention to the quality and safety of their products. Discover sinks and taps that will change your kitchen. Their comprehensive bathroom equipment allows you to create a space perfect for daily care rituals. High quality products and innovative solutions make every moment spent in the bathroom a real pleasure.",
    karrayDescription: "K-Array is an Italian audio company specializing in ultra-slim, high-performance speaker systems. Founded in 1990, they create innovative solutions for professional audio applications, from concerts and events to architectural installations. Their speakers are designed to be virtually invisible while delivering exceptional sound quality.",
    victoriaAlbertDescription: "Victoria + Albert Baths is a British brand with a worldwide reputation for creating beautiful freestanding baths and basins. Formed in 1996 with a passion for baths and bathing, the organisation has a head office in the United Kingdom and dedicated South African production facilities. Today, Victoria + Albert's international roots fuse together global design, sales and marketing operations with in-house manufacturing to deliver luxurious, lasting products. As the ultimate statement in quality and style, our model line-up is packed with inspirational freestanding designs made from 100% QUARRYCAST™, a blend of Volcanic Limestone™ and high performance resins. Naturally white, each item is individually hand-finished by craftsmen.",
    nokenDescription: "Noken is a premium bathroom brand from the PORCELANOSA Group, specializing in innovative bathroom solutions. With a focus on cutting-edge design and sustainability, Noken offers freestanding baths, basins, faucets, and shower systems that combine elegance with advanced technology.",
    teceDescription: "TECE is a German manufacturer of premium sanitary installation systems. Founded in 1955, TECE specializes in toilet flush plates, shower drains, cisterns, and installation systems. Known for their innovative design and engineering excellence, TECE products combine functionality with contemporary aesthetics.",
    tresDescription: "TRES is a Spanish manufacturer of premium bathroom and kitchen faucets. Founded in 1947, TRES combines over 75 years of experience with cutting-edge technology to create innovative faucet solutions. Known for their exceptional quality, modern design, and wide range of exclusive finishes including 24K Gold and Matte Rose Gold, TRES products bring luxury and functionality to every space.",
    decorWaltherDescription: "Decor Walther is a German manufacturer of premium bathroom accessories and mirrors. Founded in 1973, the brand stands for timeless elegance, outstanding craftsmanship, and the highest quality standards. From illuminated mirrors and soap dispensers to towel rails and bathroom shelves, every Decor Walther product is designed to transform the bathroom into a luxurious retreat.",
    excellentDescription: "Excellent is a Polish manufacturer specializing in premium bathroom solutions including shower enclosures, shower trays, bathtubs, and basins. Known for innovative glass technology and modern design, Excellent products combine functionality with contemporary aesthetics to create beautiful bathroom spaces.",
  },

  // Brands section
  brands: {
    tagline: "Exclusive Partners",
    title: "Our Brands",
  },

  // Cookie consent
  cookies: {
    bannerText: "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    learnMore: "Learn more",
    acceptAll: "Accept All",
    declineOptional: "Essential Only",
  },

  // Cookies Policy page
  cookiesPolicy: {
    title: "Cookie Policy",
    lastUpdated: "Last updated",
    whatAreCookiesTitle: "What Are Cookies?",
    whatAreCookiesText: "Cookies are small text files that are stored on your device (computer, tablet, or mobile phone) when you visit a website. They are widely used to make websites work more efficiently, provide a better user experience, and supply information to the website owners.",
    howWeUseTitle: "How We Use Cookies",
    howWeUseText: "SIA \"Royal Bathrooms\" (registration number 40103384776, VAT number LV40103384776), operating under the HAUS brand, uses cookies on this website for the purposes described below. By using our website, you agree to the use of cookies in accordance with this Cookie Policy and the EU General Data Protection Regulation (GDPR) as implemented in Latvian law.",
    essentialTitle: "Essential Cookies",
    essentialText: "These cookies are strictly necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt out of these cookies as the website cannot function without them.",
    essentialItem1: "Session management — keeping you logged in during your visit",
    essentialItem2: "Cookie consent preferences (cookie-consent) — remembering your cookie choices, stored in localStorage",
    essentialItem3: "Shopping cart — maintaining your cart contents while you browse",
    analyticsTitle: "Analytics Cookies (Google Analytics 4)",
    analyticsText: "We use Google Analytics 4 (GA4, Measurement ID: G-6J439RCQ4P) to understand how visitors interact with our website. These cookies are only activated after you give your explicit consent via the cookie banner. GA4 sets the following cookies: _ga (duration: 2 years, used to distinguish users), _ga_* (duration: 2 years, used to maintain session state). All collected data is aggregated and anonymized. Google Analytics data may be processed on servers located outside the European Economic Area (EEA), including the United States. Google participates in the EU-U.S. Data Privacy Framework. If you do not consent to these cookies, no analytics data will be collected.",
    marketingTitle: "Marketing Cookies (Meta Pixel)",
    marketingText: "We use Meta Pixel (Facebook Pixel, ID: 3229144413891730) to measure the effectiveness of our advertising and to deliver relevant ads. Meta Pixel sets the following cookies: _fbp (duration: 3 months, used for ad delivery and measurement), fr (duration: 3 months, used for ad targeting). Data collected by Meta Pixel may be transferred to servers in the United States. Meta participates in the EU-U.S. Data Privacy Framework. These cookies are used for remarketing and audience analysis.",
    thirdPartyTitle: "Third-Party Cookies",
    thirdPartyText: "Some cookies are placed by third-party services that appear on our pages. We use third-party services such as Shopify (for e-commerce functionality) and embedded content. These third parties may set their own cookies subject to their respective privacy policies. We do not control these third-party cookies.",
    dataTransferTitle: "International Data Transfers",
    dataTransferText: "Some of the third-party services we use (Google, Meta) may process data outside the European Economic Area (EEA). These transfers are safeguarded by the EU-U.S. Data Privacy Framework and/or Standard Contractual Clauses approved by the European Commission, in accordance with Article 46 of the GDPR.",
    managingTitle: "Managing Your Cookies",
    managingText: "You can manage your cookie preferences through our cookie consent banner when you first visit the site. You can also control cookies through your browser settings. Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites. Please note that disabling essential cookies may affect the functionality of our website. You can withdraw your consent at any time by clearing your browser cookies and revisiting our site — the consent banner will appear again.",
    yourRightsTitle: "Your Rights Under GDPR",
    yourRightsText: "Under the General Data Protection Regulation (GDPR) and Latvian data protection law, you have the right to: access your personal data, request correction or deletion of your data, restrict or object to data processing, data portability, and lodge a complaint with the Latvian Data State Inspectorate (Datu valsts inspekcija, www.dvi.gov.lv). To exercise any of these rights, please contact us using the details below.",
    changesTitle: "Changes to This Policy",
    changesText: "We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.",
    contactTitle: "Contact Us",
    contactText: "If you have any questions about our use of cookies, this Cookie Policy, or wish to exercise your data protection rights, please contact us at:",
  },

  // Privacy Policy page
  privacyPolicy: {
    seoTitle: "Privacy Policy | HAUS",
    seoDescription: "Learn how HAUS collects, uses, and protects your personal data in accordance with GDPR and Latvian data protection law.",
    title: "Privacy Policy",
    lastUpdated: "Last updated",
    introTitle: "Introduction",
    introText: "This Privacy Policy explains how SIA \"Royal Bathrooms\", operating under the HAUS brand, collects, uses, stores, and protects your personal data when you use our website www.haus.lv and our services. We are committed to protecting your privacy in accordance with the EU General Data Protection Regulation (GDPR) and the Latvian Personal Data Processing Law.",
    controllerTitle: "Data Controller",
    controllerText: "The data controller responsible for your personal data is:",
    controllerName: "SIA \"Royal Bathrooms\"",
    controllerRegNr: "Registration No.: 40103384776",
    controllerAddress: "Address: Cēsu iela 31 k-3, Rīga, LV-1012, Latvia",
    controllerEmail: "Email: haus@royal-bathrooms.com",
    controllerPhone: "Phone: +371 6737 6780",
    dataWeCollectTitle: "What Data We Collect",
    dataWeCollectIntro: "We collect different types of personal data depending on how you interact with our website:",
    orderDataTitle: "Order & Customer Data",
    orderDataText: "When you place an order or create an account, we collect:",
    orderDataItem1: "Name and surname",
    orderDataItem2: "Email address",
    orderDataItem3: "Phone number",
    orderDataItem4: "Delivery and billing address",
    orderDataItem5: "Order history and payment information (processed securely by Shopify Payments)",
    businessDataTitle: "Business Customer Data",
    businessDataText: "For business customers, we additionally collect: company name, registration number, VAT number, authorized contact person details, and billing/delivery addresses for invoicing purposes.",
    technicalDataTitle: "Technical & Analytics Data",
    technicalDataText: "When you browse our website, we may collect: IP address (anonymized), browser type and version, device information, pages visited, and interaction data — only with your consent via cookies (see our Cookie Policy).",
    legalBasisTitle: "Legal Basis for Processing",
    legalBasisText: "We process your personal data based on the following legal grounds under Article 6 of the GDPR:",
    legalBasisItem1: "Contract performance — processing necessary to fulfill your order or provide our services (Art. 6(1)(b))",
    legalBasisItem2: "Legal obligation — processing required by Latvian tax, accounting, or commercial law (Art. 6(1)(c))",
    legalBasisItem3: "Consent — for analytics cookies and marketing communications, which you can withdraw at any time (Art. 6(1)(a))",
    legalBasisItem4: "Legitimate interest — for website security, fraud prevention, and improving our services (Art. 6(1)(f))",
    purposeTitle: "Purposes of Data Processing",
    purposeItem1: "Processing and fulfilling your orders, including delivery and invoicing",
    purposeItem2: "Managing your customer account and providing customer support",
    purposeItem3: "Complying with legal and tax obligations under Latvian law",
    purposeItem4: "Analyzing website usage to improve our services (with your consent)",
    purposeItem5: "Sending marketing communications (only with your explicit consent)",
    sharingTitle: "Data Sharing",
    sharingText: "We may share your personal data with the following categories of recipients, only to the extent necessary:",
    sharingItem1: "Shopify Inc. — our e-commerce platform provider, which processes order and payment data",
    sharingItem2: "Delivery service providers — to fulfill your orders",
    sharingItem3: "Google LLC — for website analytics (Google Analytics 4), only with your consent",
    sharingItem4: "Meta Platforms Inc. — for advertising measurement (Meta Pixel), only with your consent",
    transferTitle: "International Data Transfers",
    transferText: "Some of our service providers (Shopify, Google, Meta) may process data outside the European Economic Area (EEA), including in the United States and Canada. These transfers are protected by the EU-U.S. Data Privacy Framework, Standard Contractual Clauses approved by the European Commission, and/or adequacy decisions, in accordance with Articles 45-46 of the GDPR.",
    retentionTitle: "Data Retention",
    retentionText: "We retain your personal data only for as long as necessary for the purposes described in this policy. Order data is retained for 5 years after the transaction as required by Latvian tax and accounting legislation (Likums \"Par grāmatvedību\"). Account data is retained until you request deletion. Analytics data is anonymized and aggregated. You may request deletion of your data at any time, subject to legal retention requirements.",
    rightsTitle: "Your Rights",
    rightsText: "Under the GDPR and Latvian data protection law, you have the following rights regarding your personal data:",
    rightsItem1: "Right of access — obtain a copy of your personal data we process",
    rightsItem2: "Right to rectification — correct inaccurate or incomplete data",
    rightsItem3: "Right to erasure — request deletion of your data (\"right to be forgotten\")",
    rightsItem4: "Right to restriction — limit how we process your data",
    rightsItem5: "Right to data portability — receive your data in a structured, machine-readable format",
    rightsItem6: "Right to object — object to processing based on legitimate interest or direct marketing",
    rightsComplaint: "You also have the right to lodge a complaint with the Latvian Data State Inspectorate (Datu valsts inspekcija): www.dvi.gov.lv, email: info@dvi.gov.lv, address: Elijas iela 17, Rīga, LV-1050.",
    securityTitle: "Data Security",
    securityText: "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. Our website uses SSL/TLS encryption for all data transmission. Access to personal data is restricted to authorized personnel only.",
    changesTitle: "Changes to This Policy",
    changesText: "We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or legal requirements. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.",
    contactTitle: "Contact Us",
    contactText: "If you have any questions about this Privacy Policy, wish to exercise your data protection rights, or have concerns about how we handle your personal data, please contact us at:",
  },
};

export type TranslationKeys = typeof en;
